/**
 * Decorative help-desk vector for the sign-in page's dark panel: a headset over a
 * ticket card, with a reply bubble ticked off. Pure SVG, Sailix teal on the rail
 * colour, so it follows the theme tokens and costs no request.
 */
export function HelpDeskIllustration() {
  return (
    <svg
      className="auth-illustration"
      viewBox="0 0 520 400"
      role="img"
      aria-label="Help desk: a headset above a support ticket with a resolved reply"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <defs>
        <linearGradient id="hd-glow" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#01AEC3" stopOpacity="0.35" />
          <stop offset="1" stopColor="#01AEC3" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="hd-card" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#393E46" />
          <stop offset="1" stopColor="#2A2F38" />
        </linearGradient>
      </defs>

      {/* soft halo */}
      <circle cx="260" cy="200" r="170" fill="url(#hd-glow)" />
      <circle cx="260" cy="200" r="138" stroke="#01AEC3" strokeOpacity="0.25" strokeWidth="1.5" strokeDasharray="4 8" />

      {/* ticket card */}
      <g transform="translate(120 150)">
        <rect x="0" y="0" width="280" height="190" rx="16" fill="url(#hd-card)" stroke="rgba(255,255,255,0.14)" strokeWidth="1.5" />
        <rect x="0" y="0" width="280" height="44" rx="16" fill="rgba(255,255,255,0.05)" />
        <rect x="0" y="28" width="280" height="16" fill="rgba(255,255,255,0.05)" />
        <circle cx="26" cy="22" r="7" fill="#01AEC3" />
        <rect x="44" y="16" width="96" height="12" rx="6" fill="rgba(255,255,255,0.72)" />
        <rect x="200" y="14" width="60" height="16" rx="8" fill="#01AEC3" fillOpacity="0.25" stroke="#01AEC3" strokeWidth="1.5" />
        <rect x="211" y="20" width="38" height="4" rx="2" fill="#7FE3EE" />
        <rect x="24" y="66" width="190" height="10" rx="5" fill="rgba(255,255,255,0.28)" />
        <rect x="24" y="88" width="232" height="10" rx="5" fill="rgba(255,255,255,0.18)" />
        <rect x="24" y="110" width="150" height="10" rx="5" fill="rgba(255,255,255,0.18)" />
        <rect x="24" y="146" width="34" height="22" rx="11" fill="rgba(255,255,255,0.10)" />
        <rect x="66" y="146" width="48" height="22" rx="11" fill="rgba(255,255,255,0.10)" />
        <rect x="122" y="146" width="40" height="22" rx="11" fill="rgba(255,255,255,0.10)" />
      </g>

      {/* reply bubble, resolved */}
      <g transform="translate(330 232)">
        <path d="M18 0h104a18 18 0 0 1 18 18v52a18 18 0 0 1-18 18H46l-26 22v-22h-2A18 18 0 0 1 0 70V18A18 18 0 0 1 18 0Z" fill="#01AEC3" />
        <path d="M38 46l18 18 36-40" stroke="#1C2129" strokeWidth="7" />
      </g>

      {/* headset */}
      <g transform="translate(180 44)" stroke="#EEEEEE" strokeWidth="7">
        <path d="M22 118V86a58 58 0 0 1 116 0v32" />
        <rect x="6" y="100" width="34" height="52" rx="12" fill="#01AEC3" stroke="#01AEC3" />
        <rect x="120" y="100" width="34" height="52" rx="12" fill="#01AEC3" stroke="#01AEC3" />
        <path d="M137 152v14a22 22 0 0 1-22 22H96" />
        <circle cx="86" cy="188" r="9" fill="#EEEEEE" stroke="#EEEEEE" />
      </g>

      {/* sparks */}
      <g stroke="#7FE3EE" strokeWidth="3">
        <path d="M84 112v18M75 121h18" />
        <path d="M448 96v14M441 103h14" />
        <path d="M420 318v12M414 324h12" />
      </g>
    </svg>
  );
}
